const Sos = {

    "sos": "SOS",
    "sos_module": "SOS Emergency",
    "tab_sos": "SOS",
    "tab_configuration": "Configuration",

    "description": "In case of an emergency, press the button below to instantly send an SOS alert to your configured emergency contacts and security personnel.",
    "sos_description": "Description",
    "send_sos": "Send SOS",
    "sending_sos": "Sending...",
    "confirm_sos_title": "Send Emergency SOS?",
    "confirm_sos_text": "This will immediately notify your emergency contacts. Are you sure you want to proceed?",
    "success_sos": "SOS alert sent successfully",
    "error_sos": "Failed to send SOS alert",

    "emergency_contacts": "Emergency Contacts",
    "add_contact": "Add Contact",
    "edit_contact": "Edit Contact",
    "name": "Name",
    "mobile_number": "Mobile Number",
    "mobile": "Mobile",
    "no_contacts": "No emergency contacts configured yet",
    "contact": "Contact",

    "ticket_file": "Ticket File",
    "error_max_files": "Maximum 10 files allowed",

    "error_description": "Enter Description",
    "error_name": "Enter Name",
    "error_mobile_number": "Enter Mobile Number",
    "error_invalid_mobile": "Invalid Mobile Number",

}

export default Sos;